export default __webpack_public_path__ + "static/cp-e17b31c6e5ed25ecb845a36ae87957cb.mp4";